import {setClusterFeature_actionType} from "../constants";

export const setClusterFeature = (feature) => {
  return {
    type: setClusterFeature_actionType,
    payload: feature,
  }
};
